module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_8.452a5f16.png";